<!--suppress CheckEmptyScriptTag -->
<template>
  <svg class="svg-right"
       id="right"
       xmlns="http://www.w3.org/2000/svg"
       x="0px"
       y="0px" viewBox="0 0 32 32"
       xml:space="preserve">
    <polyline fill="none" stroke="#796E65" stroke-linecap="round" stroke-linejoin="round"
              points="12.529,24.92484 21.467,15.98784 12.534,7.05484 "
              class="stroke"/>
  </svg>
</template>

<script>
/**
 * SVG icon.
 */
export default {
  name: 'SvgUp',
  props: ['fill', 'stroke']
}
</script>
